
const gotAnyAnswer=(values,answers)=>{
    let anyAnswer = false
    answers.map(answer => {
        if (!anyAnswer && values[answer.field]) {
            anyAnswer = true
        }
    })
    return anyAnswer
}

const isAllRequireQuestionsGotAnswer=(values,questions)=>{
    let gotAnyQuestionAnswer = false
    questions.map(question => {
        let anyAnswer = gotAnyAnswer(values,question.answers)
        if (!gotAnyQuestionAnswer && anyAnswer){
            gotAnyQuestionAnswer = true
        }
    })
    return gotAnyQuestionAnswer
}

const validate = (values,props) => {
    const errors = {};
    const { imgCate } = props
    const { imgCateQuestions } = imgCate
    
    const questions = imgCateQuestions.filter(question=> question.mandatory == true)
    questions.map(question => {
        question.answers.map(answer => {
            if (values[answer.field] && answer.subAnswers){
                if (!gotAnyAnswer(values,answer.subAnswers)){
                    errors[answer.field] = 'Please select at least one answer.'
                }
                answer.subAnswers.map(subAnswer => {
                    if (values[subAnswer.field] && subAnswer.subAnswers){
                        if (!gotAnyAnswer(values,subAnswer.subAnswers)){
                            errors[subAnswer.field] = 'Please select at least one answer.'
                        }
                        subAnswer.subAnswers.map(thirdSubAnswer => {
                            if (values[thirdSubAnswer.field] && thirdSubAnswer.subAnswers){
                                if (!gotAnyAnswer(values,thirdSubAnswer.subAnswers)){
                                    errors[thirdSubAnswer.field] = 'Please select at least one answer.'
                                }
                            }
                        })
                    }
                })
            } 
        })
    })

    if (!(values['hasNone'] || values['imageNotLoad']) &&  JSON.stringify(errors) == '{}'){
        let imgCateForm = imgCate.imgCateForm
        if (!imgCateForm) imgCateForm={}
        if (isAllRequireQuestionsGotAnswer(values,questions)){
            imgCateForm.readyToSubmit=true
        }else {
            imgCateForm.readyToSubmit=false
        }
        props.changeFieldValue('readyToSubmit',imgCateForm.readyToSubmit)
    }else {
        props.changeFieldValue('readyToSubmit',false)
    }

    return errors;
}

export default validate


// WEBPACK FOOTER //
// ./src/views/ImageCategorisation/validate.js